/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      // JavaScript to be fired on all pages
      init: function() {
        // Variables
        var siteBody = $("body, html");
        var slideCarousel = $(".case-studies-carousel");
        var mobMenuButton = $(".menu-fa");
        var mobMenu = $(".mobile-navigation");
        var closeButton = $(".close-button");
        var firstIntroImage = $(".back-image .first-intro-image");
        var lastIntroImage = $(".front-image");

        // Call Functions
        handleCarousel(slideCarousel);
        handleFixedHeader();
        handleMobHeader(mobMenuButton, mobMenu, closeButton, siteBody);

        handleImageTransition();

        // Initialize Animate on Scroll (Not on Mobile)
        AOS.init({
          disable: 'mobile',
          offset: 300
        });

        // Ensures that AOS fires
        window.addEventListener('load', AOS.refresh);
      },
      finalize: function() {
        var firstIntroImage = $(".back-image .first-intro-image");
        var lastIntroImage = $(".front-image");

        // Handle Image Resize at the top of the page
        handleImageResize(firstIntroImage, lastIntroImage);
        setInterval(function(){ handleImageResize(firstIntroImage, lastIntroImage); }, 500);
        $( window ).resize(function() {
          handleImageResize(firstIntroImage, lastIntroImage);
        });
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.

// Methods
function handleCarousel(slideCarousel) {
  // Initialize Carousel
  slideCarousel.slick({
    dots: true,
    arrows: false,
    fade: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 7000,
    responsive: [
      {
        breakpoint: 500,
        settings: {
          fade: false,
        }
      }
    ]
  });

  // Carousel before and after change, remove class and then re-add for animation
  slideCarousel.on("beforeChange", function (event, slick, currentSlide, nextSlide){
    $('.slick-slide').find( ".case-studies-background, .case-studies-content, h2, .header-wrapper, p, .button-wrapper, img, .case-studies-image" ).removeClass('aos-animate');
  });

  slideCarousel.on("afterChange", function (){
    $('.slick-current').find( ".case-studies-background, .case-studies-content, h2, .header-wrapper, p, .button-wrapper, img, .case-studies-image" ).addClass('aos-animate');
  });
}

function handleImageResize(firstIntroImage, lastIntroImage) {
  var firstIntroImageHeight = parseInt(firstIntroImage.css("height"));
  var x = window.matchMedia("(max-width: 500px)");
  var calculatedHeight;
  if (x.matches) { // If media query matches
    calculatedHeight = firstIntroImageHeight / 1.4;
  } else {
    calculatedHeight = firstIntroImageHeight / 1.8;
  }

  lastIntroImage.css("margin-top", "-" + calculatedHeight + "px");
}

function imageResizeResponsive(x) {

}

function handleFixedHeader() {
  // If scrolled past 100px
  if ($(window).scrollTop() > 100) {
    $(".banner-fixed").css({
      'top': '0'
    });
  }

  // On scroll, initialize fixed header
  $(window).scroll(function() {
      if ($(window).scrollTop() > 100) {
        $(".banner-fixed").css({
          'top': '0'
        });
      }
      else {
        $(".banner-fixed").css({
          'top': '-100px'
        });
      }
  });
}

function handleImageTransition() {

}

function handleMobHeader(mobMenuButton, mobMenu, closeButton, siteBody) {
  mobMenuButton.click(function() {
    mobMenu.fadeIn();
    siteBody.css('overflow', 'hidden');
    // Disable scrolling.
    document.ontouchmove = function (e) {
      e.preventDefault();
    }
  });

  closeButton.click(function() {
    mobMenu.fadeOut();
    siteBody.css('overflow', 'initial');
    // Enable scrolling.
    document.ontouchmove = function (e) {
      return true;
    }
  });
}
